import { render, staticRenderFns } from "./PurchasePlanInputTab.vue?vue&type=template&id=2d65e40b&"
import script from "./PurchasePlanInputTab.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanInputTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports